export default __webpack_public_path__ + "static/img-less-admin-transfert-87e3dc7fbd71c10bba4701f201e923dd.png";